import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { noWindow } from '../utils';
var EnrichQueryString = /*#__PURE__*/_createClass(function EnrichQueryString(name, value) {
  var _this = this;
  _classCallCheck(this, EnrichQueryString);
  _defineProperty(this, "name", void 0);
  _defineProperty(this, "value", void 0);
  // first check if value exists, get the value else assign empty string
  _defineProperty(this, "update", function () {
    if (!noWindow()) {
      var queryParams = window.location.search;
      _this.value = _this.value || queryParams;
    }
  });
  _defineProperty(this, "getEnrichValue", function () {
    return _this.value;
  });
  this.name = name;

  // checking for undefined to pass null/empty string/0
  if (value !== undefined) {
    this.value = value;
  }
});
export { EnrichQueryString as default };